<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import {computed, inject, ref} from 'vue';
import ChangeLogViewModal from './ChangeLogViewModal.vue';
import moment from 'moment';

const props = defineProps({
  changeLogs: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});

const trans = inject('trans');

const headers = [
  {text: trans('common.date'), value: 'createdAt', align: 'start'},
  {text: trans('common.user'), value: 'user', align: 'start'},
  {text: trans('common.description'), value: 'title', align: 'start'},
  {text: trans('common.category'), value: 'category', align: 'start'},
  {text: trans('common.action'), value: 'action', align: 'start'},
  {text: '', value: 'view.action', align: 'start'},
];

const changeLogs = computed(() =>
  props.changeLogs.data.map(item => ({
    ...item,
    user: !item.impersonator
      ? item.user?.name || '-' // If the impersonator and user is null. This is a change from the system
      : {
        title: item.user.name,
        subtitle: trans('audit.impersonated_by_x', {name: item.impersonator.name}),
      },
    createdAt: moment(item.createdAt).format('D MMM, YYYY HH:mm:ss'),
  })),
);

const filters = ref(props.filters);
const changeLogToShow = ref(null);

const pagination = computed(() => {
  const {data, ...rest} = props.changeLogs;

  return rest;
});

const showChanges = changeLog => {
  changeLogToShow.value = changeLog;
};
</script>

<template>
  <datatable :filters="filters" :headers="headers" :items="changeLogs" :loading="false" :pagination="pagination">
    <template #item-view-action="{ item }">
      <button class="tile-button" type="button" @click="showChanges(item)">
        <svg class="icon">
          <use xlink:href="#eye-icon"></use>
        </svg>
      </button>
    </template>
  </datatable>
  <change-log-view-modal
    v-if="changeLogToShow !== null"
    :change-log="changeLogToShow"
    @close="changeLogToShow = null"
  />
</template>
